"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLabels = void 0;
var getLabels = function getLabels(productType) {
  if (productType === 'IF') {
    return {
      payment: 'Sample equal monthly payment',
      period: 'Promotional period',
      apr: 'APR during promotional period'
    };
  }
  if (productType === 'PRP') {
    return {
      payment: 'Monthly payment',
      period: 'Promotional period',
      apr: 'APR during promotional period'
    };
  }
  return {
    payment: 'Monthly payment',
    period: 'Number of payments',
    apr: 'APR'
  };
};
exports.getLabels = getLabels;
